export default __webpack_public_path__ + "static/media/copy.045a0836.svg";